export enum RegistrationPaymentStatus{
    PAYMENT_AVAILABLE = 'PAYMENT_AVAILABLE',
    PAYMENT_PENDING = 'PAYMENT_PENDING',
    PAYMENT_STARTED = 'PAYMENT_STARTED',
    PAYMENT_CONFIRMED = 'PAYMENT_CONFIRMED',
    PAYMENT_FAILED = 'PAYMENT_FAILED',
    PAYMENT_ABANDONED = 'PAYMENT_ABANDONED',
    PAYMENT_MANUAL_VALIDATION = 'PAYMENT_MANUAL_VALIDATION',
    PAYMENT_MANUALLY_APPROVED = 'PAYMENT_MANUALLY_APPROVED',
    PAYMENT_MANUALLY_REJECTED = 'PAYMENT_MANUALLY_REJECTED',
}